<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <!-- Add New Popup -->
      <div class="form-panel w-20" :class="{ 'is-open': addPopup }">
        <span @click="popup_close" class="close text-end">&times;</span>
        <div class="form-header">
          <h5 v-if="Object.keys(single_data).length">Edit Data</h5>
          <h5 v-else>Add Data</h5>
          <span @click="popup_close" class="item">
            <Close />
          </span>
        </div>
        <div class="d-flex flex-column"  style="gap: 10px">
            <div>
              <label class="form-label">Service Name</label>
              <input
                v-model="formData.name"
                type="text"
                placeholder="Service Name"
                class="form-control invoice-card"
              />
            </div>
            <div>
              <label class="form-label">Status</label>
              <select v-model="formData.status_service" class="form-control invoice-card">
                <option value="" disabled>Select Area</option>
                <option value="active" >Active</option>
                <option value="inactive">Inactive</option>
                <!-- Add other areas as needed -->
              </select>
            </div>
          <div>
            <div class="grid grid-cols-2 gap-2">
              <!-- <button class="btn btn-secondary mx-3" @click="popup_close">
                Cancel
              </button> -->
              <button
                v-if="Object.keys(single_data).length"
                class="btn btn-success"
                @click="submitForm"
              >
                Update
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm mx-3"
                ></span>
              </button>
              <button v-else class="btn btn-success" @click="submitForm">
                Save
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm mx-3"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card invoice">
          <div class="pb-0 card-header invoice">
            <div class="d-lg-flex justify-content-between mx-3">
              <div>
                <h5>
                  Service List <span class="badge">{{ filteredData.length }}</span>
                </h5>
              </div>
              <div class="d-flex gap-3">
                <div class="flex-grow-1">
                  <button @click="addPopup = true" class="btn btn-success">
                    Add New
                  </button>
                </div>
                <div class="flex-grow-1">
                  <input
                    type="text"
                    v-model="searchQuery"
                    class="form-control invoice"
                    placeholder="Search..."
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="px-0 pb-0 card-body">
            <div class="table-responsive" v-if="data && data.length > 0">
              <div class="card mb-4">
                <div class="card-body px-0 pt-0 pb-2 invoice">
                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Action
                          </th>
                          <th
                            @click="sort('name')"
                            :class="{
                              asc: sortKey === 'name' && sortOrder === 'asc',
                              desc: sortKey === 'name' && sortOrder === 'desc',
                            }"
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Service Name
                          </th>
                          <th
                            @click="sort('status_service')"
                            :class="{
                              asc: sortKey === 'status_service' && sortOrder === 'asc',
                              desc: sortKey === 'status_service' && sortOrder === 'desc',
                            }"
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Status
                          </th>
                          <th
                            class="text-secondary opacity-7"
                          ></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in paginatedData" :key="index">
                          <td class="text-center">
                            <template v-if="hasPermission('2023')">
                            <soft-badge @click="editItem(item)" class="bg-success p-1 rounded-1 text-white cursor-pointer text-sm mx-3" variant="gradient" size="sm">Edit</soft-badge>
                            <soft-badge @click="deleteItem(item.id)" class="bg-danger p-1 rounded-1 text-white cursor-pointer text-sm mx-3" variant="gradient" size="sm">Delete</soft-badge>
                            </template>
                          </td>
                          <td>{{ item.name }}</td>
                          <td>
                            <span :class="item.status_service == 'active' ? 'active-status' : 'inactive-status'">
                              {{ item.status_service == 'active' ? "Active" : "Inactive" }}
                            </span>
                          </td>
                          
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p>No POPs available. Please add one.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useServiceApi } from '@/services/services.service';
import { hasPermission } from "@/utils/permissions.js";
import showSwal from "@/mixins/showSwal.js"; 
export default {
  data() {
    return {
      data: [], 
      filteredData: [], 
      searchQuery: '',
      addPopup: false,
      formData: {
        id: null,
        name: '',
        status_service: '',
      },
      single_data: {},
      loading: false,
      sortKey: '',
      sortOrder: '',
    };
  },
  computed: {
    paginatedData() {
      return this.filteredData; 
    },
  },
  methods: {
    hasPermission,
    async fetchData() {
      try {
        const response = await useServiceApi().getService();  
        this.data = response;
        this.filteredData = this.data; 
      } catch (error) {
        console.error("Error fetching service data:", error);
      }
    },
    submitForm() {
      if (this.formData.id) {
        this.updateItem(this.formData);
      } else {
        this.createItem(this.formData);
      }
    },
    async createItem(formData) {
      this.loading = true;
      try {
        await useServiceApi().createService(formData);
        this.fetchData(); // Refresh data after creating
        this.popup_close();
      } catch (error) {
        console.error("Error creating item:", error);
      } finally {
        this.loading = false;
      }
    },
    async updateItem(formData) {
      this.loading = true;
      try {
        await useServiceApi().updateService(formData.id, formData);
        this.fetchData(); // Refresh data after update
        this.popup_close();
      } catch (error) {
        console.error("Error updating item:", error);
      } finally {
        this.loading = false;
      }
    },
    async deleteItem(id) {
      if (!hasPermission("2024")) {
        showSwal.methods.showSwal({
                type: "error",
                  message: "You do not have permission to perform this action.",
                });
        return;
      }
      this.loading = true;
      try {
        await useServiceApi().deleteService(id);
        this.fetchData(); 
      } catch (error) {
        console.error("Error deleting item:", error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      if (!hasPermission("2024")) {
        showSwal.methods.showSwal({
                type: "error",
                  message: "You do not have permission to perform this action.",
                });
        return;
      }
      this.formData = { ...item };
      this.addPopup = true;
    },
    popup_close() {
      this.addPopup = false;
      this.formData = { id: null, name: '', status_service: '', area: '' };
    },
    sort(column) {
      if (this.sortKey === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = column;
        this.sortOrder = 'asc';
      }
      this.filteredData.sort((a, b) => {
        const valA = a[column];
        const valB = b[column];
        if (this.sortOrder === 'asc') {
          return valA > valB ? 1 : -1;
        } else {
          return valA < valB ? 1 : -1;
        }
      });
    },
  },

   watch: {
            searchQuery(newValue) {
                this.filteredData = this.data.filter(item => {
                    for (let key in item) {
                        if (String(item[key]).toLowerCase().includes(newValue.toLowerCase())) {
                            return true;
                        }
                    }
                    return false;
                });
                this.currentPage = 1;
            }
        },
  mounted() {
    this.fetchData(); 
  },
};
</script>


<style>
/* The Modal (background) */
.modal_class {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #aaaaaa;
}

/* Modal Content/Box */
.modal-content {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 50%;
  padding: 20px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

td {
  padding: 12px 24px !important;
}

.sort-icon {
  margin-left: 5px;
}

.asc::after {
  content: "▲";
}

.desc::after {
  content: "▼";
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 50%;
  background-color: #40c133;
  /* or any other color you prefer */
  color: #fff;
  /* text color */
}

.has-error .form-control {
  border: 1px solid red;
}
.has-success .form-control {
  border: 1px solid green;
}
.check-icon {
  color: green !important;
  position: absolute;
  right: 20px;
  top: 37px;
}
.cross-icon {
  color: red !important;
  position: absolute;
  right: 20px;
  top: 37px;
}

/* ===============panel---------- */
.form-panel {
  position: fixed;
  top: 0;
  right: -100%;
  height: 100%;
  width: 400px;
  background: #fff;
  transition: all 0.3s ease;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 1050;
}
.dark-mode .form-panel {
  background-color: #061f3e !important;
}
.form-panel.is-open {
  right: 0;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dark-mode .bg {
  background-color: #061f3e !important;
  color: white;
}
</style>